'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gdprConsentToCommunicateEnabled = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getMessage = require('./getMessage');

var _getGdprConsentToCommunicateEnabled = require('../message/getGdprConsentToCommunicateEnabled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gdprConsentToCommunicateEnabled = exports.gdprConsentToCommunicateEnabled = (0, _pipe2.default)(_getMessage.getMessage, _getGdprConsentToCommunicateEnabled.getGdprConsentToCommunicateEnabled);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/gdprConsentToCommunicateEnabled.js
// module id = 1066
// module chunks = 2 3